export const billboardStyles = theme => ({
    billboard_sidebar: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        position: 'relative',
        maxWidth: 415,
        width: '100%',
        height: '100%',
        //padding: '4rem 2rem 0rem 1rem', TO DO
        padding: '3rem 1.5rem 0rem 1.5rem',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            maxHeight: '100%',
            order: 1,
            padding: '0 1rem',
            marginTop: '-1rem',
            '.has_no_options &': {
                height: 0,
                marginTop: 0,
                display: 'none',
            },
        },
        [theme.breakpoints.up('md')]: {
            order: 2,
            '.has_no_options &': {
                // maxWidth: '100%',
                width: '33%',
            },
            '.has_no_pois &': {
                padding: '9rem 2rem 0rem 1rem',
            }
        },
    },
    variant_title: {
        fontWeight: 600,
        fontSize: '1.75rem',
        margin: 0,
        lineHeight: 1.15,
        marginBottom: '0.25rem',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    variant_price: {
        //color: props => props.viewer_button.button_color,
        color: '#000',
        fontWeight: 600,
        lineHeight: 1,
        fontSize: '1.15rem',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    variant_description: {
        textAlign: 'right',
        marginTop: '0.5rem',
    },
    variant_options: {
        marginTop: '1rem',
        marginBottom: '1rem',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            textAlign: 'center',
            position: 'relative',
            zIndex: 6,
            marginTop: 0,
            '.has_no_pois &': {
                marginTop: '23px',
            },
        },
    },
    option_container: {
        border: '2px solid #bdbec0',
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1rem',
        padding: '0.75rem 2.5rem 0.75rem 0.75rem',
        position: 'relative',
        transition: 'all 0.5s ease',
        '&.active_option_container': {
            // color: props => props.viewer_button.button_color,
            // borderColor: props => props.viewer_button.button_color,
        },
        [theme.breakpoints.down('sm')]: {
            width: '31%',
            flexDirection: 'column-reverse',
            display: 'inline-flex',
            margin: '0 1% 1rem',
            padding: '0 0.25rem',
            borderRadius: 3,
            position: 'static',
            '&.active_option_container': {
                borderColor: '#9a9a9a',
                backgroundColor: '#bdbec0',
            },
            '&.active_option_container h6': {
                color: '#fff',
            },
        },
    },
    values_container: {
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            bottom: '142.5%',
            left: '1.5%',
            right: '1.5%',
            border: '2px solid transparent',
            background: '#fff',
            borderRadius: 3,
            zIndex: 1,
            transition: '0.25s ease',
            '.active_option_container &': {
                borderColor: '#9a9a9a',
                background: 'rgb(171 172 174 / 80%)',
            }
        },
    },
    billboard_variant_close: {
        position: 'absolute',
        top: '0.75rem',
        right: '1rem',
        width: '1.5rem',
        height: '1.5rem',
        transform: 'rotate(-90deg)',
        cursor: 'pointer',
        zIndex: 6,
        '& path': {
            fill: '#fff',
        },
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    option_values: {
        display: 'flex',
        flexWrap: 'wrap',        
        transition: 'all 0.5s ease',        
        [theme.breakpoints.down('sm')]: {
            marginTop: '-100%',
            transform: 'translateY(105%)',
            justifyContent: 'center',
            opacity: 0,
            '.active_option_container &': {
                transform: 'translateY(0)',
                marginTop: '0.5rem',
                marginBottom: '1.5rem',
                opacity: 1,
            },
        },
        [theme.breakpoints.up('md')]: {
            marginBottom: '-100%',
            transform: 'translateY(-100%)',
            justifyContent: 'flex-start',
            '.active_option_container &': {
                transform: 'translateY(0.75rem)',
                marginBottom: '0.75rem',
                padding: 8,
                outline: 'none',
                // boxShadow: "0px 0px 5px 0px #0000004d"
            },
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 320,
        textAlign: 'left',
        fontFamily: props => props.default_text_font,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    option_select: {
        border: 'none',
        borderRadius: 3,        
        padding: '0 8px 0 4px',
        lineHeight: 1,
        fontSize: '1.15rem',
        cursor: 'pointer',
        width: '100%',
        WebkitAppearance: 'none',
        appearance: 'none',
        MozAppearance: "none",
        backgroundImage: "url('https://www.svgrepo.com/show/80156/down-arrow.svg')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "10px 10px",
        backgroundPosition: "calc(100% - 10px)",
        fontFamily: props => props.default_text_font,
        [theme.breakpoints.down('sm')]: {
            maxWidth: '90%',
            marginLeft: '5%',
            marginBottom: '1rem',
            padding: '0.5rem 1rem 0.5rem 0.75rem',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '95%',
            // background: '#bdbec0',
            border: 'solid 1px #231f20',
            // color: '#fff',
        },
    },
    option_title: {
        fontSize: '1.15rem',
        margin: 0,
        lineHeight: 1,
        cursor: 'pointer',
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
            lineHeight: '2.25',
            fontSize: '1rem',
        },
    },
    option_title_mobile: {
        margin: 0,
        fontSize: '1rem',
        textAlign: 'left',
        padding: '1rem 2.5rem 0 2rem',
        color: '#fff',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    selected_value: {
        display: 'inline-block',
        fontWeight: 500,
        marginLeft: 6,
    },
    option_value: {
        margin: '0 0.5rem 0.5rem 0',
    },
    option_swatch: {
        width: '30%',        
        cursor: 'pointer',
        '& svg': {
            width: '100%',
            height: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',        
            width: 'auto',
        },
    },
    swatch_label: {
        width: 88,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('sm')]: {
            width: 58,
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: '0.25rem',
        },
    },
    expand_icon: {
        width: '1.5rem',
        position: 'absolute',
        bottom: '0.625rem',
        right: '0.5rem',
        cursor: 'pointer',
        opacity: 1,
        transition: '0.25s ease',
        '& .cls-1': {
            fill: '#000',
        },
        '.active_option_container &': {
            opacity: 0,
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    collapse_icon: {
        width: '1.5rem',
        position: 'absolute',
        bottom: '0.625rem',
        right: '0.5rem',
        cursor: 'pointer',
        opacity: 0,
        transition: '0.25s ease',
        '& .cls-1': {
            fill: '#000',
        },
        '.active_option_container &': {
            opacity: 1,
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    billboard_buttons: {
        display: 'flex',
        alignItems: 'stretch',
        marginTop: '1.5rem',
        '.has_no_pois &': {
            marginTop: 0,
        },
        '& button': {
            width: '100%',
            justifyContent: 'center',
            borderRadius: 3,
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    image_container_focus: {
        width: '50%',
        minHeight: 210, // image height
        maxHeight: 210, // image height
        borderRadius: 3,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        marginRight: '1rem',
        boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    },
    buttons_wrapper: {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        flexGrow: 1,
        // '& > div:first-child': {
        //     [theme.breakpoints.down('sm')]: {
        //         marginRight: '1rem',
        //     },
        //     [theme.breakpoints.up('md')]: {
        //         marginBottom: '1rem'
        //     },
        // },
        '& > div': {
            width: '100%',
        },
        '.has_no_options &': {
            maxWidth: 180,
            width: '50%',
        },
        // '.has_no_options & > div:nth-of-type(2) button': {
        //     flexDirection: 'column-reverse',
        //     fontSize: '1.5rem',
        // },
        // '.has_no_options & > div:nth-of-type(2) button img': {
        //     width: '100%',
        //     maxWidth: 125,
        //     marginLeft: 0,
        //     marginBottom: '.5rem',
        // }
    },
    billboard_footer: {
        display: 'flex',
        background: '#ffffff',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '1rem',
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            marginTop: 0,
            //padding: '0 0 1rem', TO DO
            padding: '.25rem 1rem 1rem',
            '.has_tabs &': {
                position: 'relative',
                boxShadow: '0px 0px 2px 0px rgb(0,0,0,0.15)',
                background: '#fefefe',
            },
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: '2rem',
            order: 3,
            maxWidth: 'calc(100% - 360px)',
            position: 'relative',
            '.has_no_options &': {
                order: 0,
                width: '12%',
                flexDirection: 'column-reverse',
                paddingLeft: '1rem',
                marginTop: 0,
                position: 'static',
            },
            '.has_no_pois &': {
                padding: 0,
                margin: 0,
                position: 'absolute',
                bottom: 0,
                // bottom: '1rem',
                background: 'transparent',
            },
        },
        [theme.breakpoints.only('md')]: {
            maxWidth: '100%',
        },
    },
    billboard_pois: {
        display: 'flex',
        flexGrow: 1,
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            order: 0,
            '.has_no_options &': {
                width: '100%',
                marginTop: '0.675rem',
            },
            '.reviews_tab_active &, .video_tab_active &': {
                display: 'none !important',
            },
        },
        [theme.breakpoints.up('md')]: {
            padding: '0 1rem 0 0',
            '.has_no_options &': {
                padding: 0,
                width: '100%',
                alignItems: 'center',
            },
        },    
    },
    billboard_icon: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            '& svg': {
                width: 35
            }
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: '1.25rem',
            '.has_no_options &': {
                marginLeft: 0,
                marginTop: '1.25rem',
            },
            '.has_no_pois &': {
                display: 'none'
            }
        },
    },
    billboard_icon_content: {
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            top: '7rem',
            right: '1rem',
            zIndex: 3,
            '.has_no_pois &': {
                top: '-3rem',
            },
            '.has_tabs &': {
                top: '-4rem',
            },
        }
    },
    billboard_info_wrapper_desktop: {
        marginTop: '1.5rem',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    billboard_info_wrapper: {
        width: '100%',
    },
    billboard_tabs_container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
    },
    billboard_tabs: {
        order: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        cursor: 'pointer',
        '& span': {
            flex: 1,
            padding: '1.125rem 1rem 0.5rem',
            textAlign: 'center',
            borderBottom: '3px solid #bdbec0',
            textTransform: 'uppercase',
        },
        '& span.active': {
            borderColor: '#231f20',
        },
        [theme.breakpoints.up('md')]: {
            order: 0,
            '&.billboard_info_tabs_mobile': {
                display: 'none',
            },
        },
    },
    billboard_tabs_body: {
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
        padding: '1.5rem 0.25rem 0',
        display: 'flex',
        '&.billboard_tabs_body_mobile': {
            display: 'none',
        },
        '.features_tab_active &': {
            display: 'none !important',
        },
        [theme.breakpoints.down('sm')]: {
            order: 3,
            background: '#ffffff',
            padding: '1.5rem 1rem',
            '&.billboard_tabs_body_mobile': {
                display: 'flex',
            },
            '&.billboard_tabs_body_desktop': {
                display: 'none',
            },         
        },
    },
    billboard_tabs_mobile: {
        flexDirection: 'column',
        zIndex: 5,
        margin: 0,
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            width: '100%',
            position: 'relative',
            //transition: '0.5s ease',
        },
    },
    billboard_info_close: {
        width: '1.5rem',
        height: '1.5rem',
        transform: 'rotate(-90deg)',
        cursor: 'pointer',
        zIndex: 6,
        '.collapsed &': {
           transform: 'rotate(90deg)',
        },
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    billboard_reviews_close: {
        marginLeft: 'auto',
        width: '1.25rem',
        '.collapsed &': {
           transform: 'rotate(90deg)',
        },
        [theme.breakpoints.up('md')]: {
            display: 'inline-block',
        },
    },
    title_container_mobile: {
        display: 'flex',
        borderBottom: 'solid 2px',
        // alignItems: 'center',
        justifyContent: 'space-between',
        background: '#ffffff',
        padding: '0.25rem'
    },
    title: {
        margin: 0,
        fontSize: '1.25rem',
        fontWeight: 600,
        // textTransform: 'uppercase',
        lineHeight: '1.25',
        // color: '#fff',
        overflow: 'hidden',
        zIndex: 5
    },
    billboard_body: {
        margin: '0.25rem 0 0',
        padding: '0.2rem',
        zIndex: 5,
        [theme.breakpoints.down('sm')]: {
            margin: 0,
            opacity: 1,
            maxHeight: 250,
            //transition: '0.5s ease',
            '& p': {
               margin: '1rem 0 0 0',
            },
            '.collapsed &': {
               maxHeight: 0,
               opacity: 0,
            },
        }
    },
    p1: {
        margin: 0,
        fontSize: '1rem',
        // color: '#fff',
        lineHeight: '1.5rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
        }
    },
    billboard_media: {
        display: 'flex',
        width: '100%',
        margin: '0 auto',
        justifyContent: 'space-between',
        zIndex: 1,
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            justifyContent: 'center',
        },
        [theme.breakpoints.up('md')]: {
            justifyContent: 'flex-end',
            '.has_no_options &': {
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
            },
        },
        [theme.breakpoints.only('md')]: {
            justifyContent: 'center',
        },
    },
    billboard_slider: {
        overflow: 'hidden',
        display: 'inline-block',
        width: 'calc(100% - 104px)',
        maxWidth: 560,
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            // maxWidth: 256,
            maxWidth: 256,
            margin: 0,
        },
        [theme.breakpoints.up('md')]: {
            margin: '0',
            '&.vertical_slider': {
                width: '100%',
                maxWidth: 150,
                maxHeight: 370,
                margin: '0.25rem 0',
            },
        },
    },
    billboard_slider_track: {
        whiteSpace: 'nowrap',
        marginLeft: 0,
        transition: '0.5s ease',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            marginTop: '0 !important',
        },
        [theme.breakpoints.up('md')]: {
            '.vertical_slider &': {
                whiteSpace: 'normal',
                textAlign: 'center',
                marginLeft: '0 !important',
            },
        },
    },
    arrow: {
        cursor: 'pointer',
        border: 'none',
        background: 'none',
        outline: 'none',
        opacity: 1,
        transition: 'all .2s ease',
        display: 'inline-flex',
        height: '100%',
        alignItems: 'center',
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',        
    },
    disabled_arrow: {
        pointerEvents: 'none',
        '& svg path': {
            fill: '#cccccc',
        },
        // '& svg': {
        //     transform: 'rotate(180deg)',
        // },
        [theme.breakpoints.up('md')]: {
            '.has_no_options &': {
                // transform: 'rotate(90deg)',
                height: 'auto',
            },
        }
    },
    prev_arrow: {
        transform: 'rotate(90deg)',
        [theme.breakpoints.down('sm')]: {
            transform: 'rotate(0deg)',
        }
    },
    next_arrow: {
        transform: 'rotate(-90deg)',
        [theme.breakpoints.down('sm')]: {
            transform: 'rotate(180deg)',
        }
    },
    image_container: {
        position: 'relative', 
        zIndex: 5, 
        display: 'inline-flex',
        alignItems: 'center',
        maxWidth: 100,
        height: 100,
        width: '33.33%',
        margin: '0 1.25rem',
        border: '3px solid #bdbec0',
        borderRadius: 3,
        padding: 4,
        cursor: 'pointer',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        boxShadow: '0 2px 9px 0 rgb(0 0 0 / 14%), 0 1px 8px 0px rgb(0 0 0 / 5%), 0 1px 7px 0 rgb(0 0 0 / 11%)',
        transition: 'border-color 0.25s ease',
        [theme.breakpoints.down('sm')]: {
            maxWidth: 64,
            // maxWidth: 75,
            height: 64,
            margin: '0 0.675rem',
        },
        [theme.breakpoints.up('md')]: {
            width: '20% !important',
            '.vertical_slider &': {
                margin: '0 0 1.25rem',
                width: '100% !important',
            },
        },
    },
    active_poi: {
        borderColor: '#ffdd02',
    },
    last_visible: {},
    increment_copy: { position: 'absolute', bottom: 5, right: 5, color: '#ffffff' },
    arrow_style: { 
        width: 40,
        height: 40,
        [theme.breakpoints.down('sm')]: {
            width: 32,
            height: 32,
        },
    },
    active_option: {
        pointerEvents: 'none'
    },
    color_container: {
        display: 'flex' 
    },
    color_swatch: {
        maxWidth: '100%', 
        maxHeight: '100%',
        height: 90,
        width: 90,
        borderRadius: 3,
        border: '2px solid #bdbec0',
        transition: '0.25s linear',
        display: 'block',
        marginBottom: '0.25rem',
        '& $active_option': {
            borderColor: '#231f20',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: 60,
            maxHeight: 60,
        },
    },
    image_swatch: {
        maxHeight: '100%',
        maxWidth: '100%',
        height: 90,
        width: 90,
        borderRadius: 3,
        border: '2px solid #bdbec0',
        transition: '0.25s linear',
        display: 'block',
        marginBottom: '0.25rem',
        '.active_option &': {
            borderColor: '#231f20',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: 60,
            maxHeight: 60,
        },
    },
    swatch_active: {
        borderColor: "#292929",
        // borderColor: props => props.viewer_button.button_color,
        borderWidth: 3
    },
    billboard_footer_buttons: {
        order: 2,
        width: '100%',
        marginTop: '0.5rem',
        display: 'flex',
        "& > div": {
            width: '100%',
        },
        "& button, & a": {
            display: 'flex',
            flexDirection: 'column-reverse',
            width: '100%',
            justifyContent: 'center',
            margin: '0',
            padding: '12px 15px 9px',
            fontSize: '1.1rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            [theme.breakpoints.down('sm')]: {
                borderRadius: 12,
            },
            '& svg': {
                marginLeft: 0,
                // marginBottom: '1rem',
                maxWidth: 50
            },
            '& img': {
                marginLeft: 0,
                // marginBottom: '1rem',
                width: '100%',
                maxWidth: 50
            },
            '& span': {
                marginTop: 10
            }
        },
        ".has_no_options &": {
            marginTop: '1rem',
        },
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    rotate_360_icon: {
        width: 40,
        '& .cls-1': {
            fill: '#bdbec0',
        },
        [theme.breakpoints.up('md')]: {
            width: 60,
        },
    },
    reviews_bottom_line: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap',
        [theme.breakpoints.up('md')]: {
            maxWidth: '98%',
        },
    },
    icon_star: {
        marginRight: '0.075rem',
        width: '1.125rem',
        '& .b': {
            strokeWidth: '20px',
        },
        [theme.breakpoints.up('md')]: {
            width: '1.5rem',
        },
    },
    full_star: {
        '& .b': {
            fill: '#ede80b',
            stroke: '#9fa1a4',
        },
    },
    empty_star: {
        '& .b': {
            fill: 'none',
            stroke: '#9fa1a4',
        },
    },
    reviews_full: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            maxHeight: 280,
            overflowY: 'scroll',
        },
    },
    review_content: {
        overflow: 'hidden',
        maxHeight: 'none',
        opacity: 1,
        '.collapsed &': {
            maxHeight: 0,
            opacity: 0,
        },
    },
    review: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1.5rem',
        paddingBottom: '1.5rem',
        borderBottom: '1px solid #bdbec0',
        '&:last-of-type': {
            borderBottom: 'none',
            marginBottom: 0,
        },
    },
    review_author: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: '0.75rem',
        marginBottom: '0.1rem',
        '& span': {
            margin: '0 0.5rem',
            display: 'inline-flex',
            alignItems: 'center',
        },
        '& span:first-of-type': {
            marginLeft: 0,
        },
        '& span:last-of-type': {
            marginRight: 0,
        },
        '& svg': {
            width: '1.375rem',
            marginBottom: '5px',
        },
    },
    review_body: {
        '& p': {
            margin: '0.5rem 0 0.5rem',
            fontSize: '0.875rem',
        },
        '& p:first-of-type': {
            marginTop: '0.25rem',
        },
        '& h3': {
            textTransform: 'uppercase',
            fontWeight: 600,
            width: 'calc(100% - 2rem)',
            margin: '0.75rem 0 0',
        },
        [theme.breakpoints.down('sm')]: {
            '& h3': {
                fontSize: '1.125rem',
            },
        },
    },
    review_variant_info: {
        display: 'flex',
        fontSize: '0.875rem',
        '& > div:first-of-type': {
            marginRight: '0.5rem',
        },
        '& > div:last-of-type': {
            marginLeft: '0.5rem',
        },
    },
    specs: {
        marginTop: '1rem',
        textAlign: 'right',
        display: 'block',
    },
    // BILLBOARDS PAGINATION COMPONENT
    billboards_pagination: {
        paddingTop: 10,
        display: 'flex',
        alignItems: 'center',
        '& button': {
            outline: 'none',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            '&:hover': {
                '& svg': {
                    transition: 'all .2s ease',
                    //fill: props => props.viewer_button.button_color TO DO
                }
            }
        },
        '& svg': {
            height: 39,
            width: 39,
            paddingRight: 22
        }
    },    
    pagination_copy_container: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 18,
        lineHeight: 1,
        color: '#000'
    },
    pagination_total: {
        color: '#737373',
        paddingLeft: 5,
        letterSpacing: 3
    },
    disabled_pagination_arrow: {
        pointerEvents: 'none',
        opacity: .5
    },
    features: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        height: '179.2vw',
        width: '100%',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            height: '151.52vw',
        },
    },
    feature: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        cursor: 'pointer',
        transition: 'all .3s ease-out',
        position: 'absolute',
        top: 0,
        width: '100%',
        overflow: 'hidden',
        minHeight: '32.26vw',
        maxHeight: '32.26vw',
        '&:first-of-type+div': {
            top: '32.26vw',
        },
        '&:last-of-type': {
            top: 'initial',
            bottom: 0,
        },
        '&.active': {
            minHeight: '114.67vw',
            maxHeight: '114.67vw',
            flex: '2.39',
            // maxHeight: '29.625rem',
            transition: 'all .3s ease-out',
            [theme.breakpoints.down('sm')]: {
                minHeight: '87vw',
                maxHeight: '87vw',
            },
        },
        '&:first-of-type.active+div': {
            top: '114.7vw',
            [theme.breakpoints.down('sm')]: {
                top: '87vw',
            },
        },
    },
    feature_media: {
        height: '100%',
        position: 'relative',
        minHeight: '32.26vw',
        transition: 'min-height .3s ease-out',
        '& img': {
            objectFit: 'cover',
            objectPosition: 'center center',
            transition: 'opacity .4s cubic-bezier(0.25,0.46,0.45,0.94)',
            display: 'block',
            maxWidth: '100%',
            position: 'absolute',
            top: 0,
            left: '50%',
            height: '100%',
            width: '100%',
            transform: 'translateX(-50%)',
        },
        '.active &': {
            minHeight: '114.67vw',
            maxHeight: '29.625rem',
            height: '100%',
            [theme.breakpoints.down('sm')]: {
                minHeight: '87vw',
            },
        },
    },
    feature_text: {
        bottom: '1.3125rem',
        position: 'absolute',
        paddingLeft: '1.3125rem',
        width: '100%',
        maxWidth: 'calc(100% - 2.625rem)',
        transition: 'padding-left .4s ease-in-out',
    },
    feature_title_wrap: {
        marginBlockStart: 0,
        marginBlockEnd: 0,
        transition: 'all .4s ease-in-out',
        position: 'absolute',
        paddingBottom: '0.3125rem',
        transitionDelay: '.2s',
        width: '100%',
        bottom: '-0.3125rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#ffffff',
        '.active &': {
            bottom: '100%',
            transitionDelay: '.4s',
        },
    },
    feature_title: {
        fontSize: '1.375rem',
        lineHeight: '1.75rem',
        color: '#ffffff',
        opacity: 1,
        transition: 'opacity .4s ease-in',
        transitionDelay: '.2s',
        fontWeight: 700,
        margin: 0,
        textTransform: 'uppercase',
        textShadow: '0px 0px 16px #000',
    },
    feature_expand_icon: {
        opacity: 1,
        transition: 'opacity .4s ease-in',
        '.active &': {
            opacity: 0,
        },
    },
    feature_copy: {
        marginBlockStart: 0,
        marginBlockEnd: 0,
        color: '#ffffff',
        opacity: 0,
        position: 'relative',
        transition: 'all .4s ease-in-out',
        transitionDelay: '.2s',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        transform: 'translateY(calc(100% + 0.3125rem))',
        maxWidth: 'calc(100% - 1.6875rem)',
        textShadow: '0px 0px 16px #000',
        '.active &': {
            opacity: 1,
            transform: 'translateY(0)',
            transitionDelay: '.4s',
        },
    },
});
